import React from "react";

export default class TextComponent extends React.Component {
  constructor(props) {
    super(props);
    this.inputId = `${Math.round(Math.random() * 10 ** 10)}`;
    this.state = {
      data: JSON.parse(JSON.stringify(this.props)),
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ data: this.props });
    }
  }

  onChangeData = e => {
    console.debug("onChangeData", e, this.state.data);
    const data = { ...this.state.data };
    data.value = e.target.value;
    this.setState(() => ({ data }));
  };

  render() {
    const { id, value, editable } = this.state.data;
    return (
      <input
        id={id || this.inputId}
        type="text"
        value={value}
        disabled={!editable}
        onChange={e => this.onChangeData(e)}
        onBlur={() => this.props.onBlurData(this.state.data.value)}
        data-test="textcomponent-text-input"
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/commonComponents/CustomGrid/CustomGridTypeComponents/TextComponent.js